import React, { useState, useEffect } from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import InsertDriveFileIcon from "@material-ui/icons/InsertDriveFile";
import CloseIcon from "@material-ui/icons/Close";
import { useDispatch, useSelector } from "react-redux";
import { OAuth as OAuthActions } from "../../js/actions";
import { setSnackbar } from "../../js/reducers/snackbar";
import { setAlertDialog } from "../../js/reducers/alertDialog";
import { useHistory } from "react-router-dom";
import Box from "@material-ui/core/Box";
import GroupIcon from "@material-ui/icons/Group";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    padding: theme.spacing(3),
    backgroundColor: "#f5f7fa",
    minHeight: "calc(100vh - 127px)",
  },
  pageHeaderLeft: {
    display: "flex",
    alignItems: "center",
    marginBottom: 24,
  },
  pageIconBox: {
    width: 40,
    height: 40,
    borderRadius: 12,
    background: "linear-gradient(135deg, #1a56db 0%, #1e40af 100%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: 12,
  },
  formCard: {
    backgroundColor: "#fff",
    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
    overflow: "hidden",
    borderRadius: 15,
  },
  formCardBody: {
    padding: theme.spacing(3),
  },
  sectionHeader: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(0.5),
  },
  sectionTitle: {
    fontSize: "0.95rem",
    fontWeight: 600,
    color: theme.palette.text.primary,
  },
  docTypeContainer: {
    display: "flex",
    gap: theme.spacing(2),
    marginBottom: theme.spacing(3),
  },
  docTypeOption: {
    flex: 1,
    padding: theme.spacing(2.5, 2),
    border: (props) =>
      props.selected === "PRIVACY_POLICY"
        ? `2px solid ${theme.palette.primary.main}`
        : "2px solid #e0e0e0",
    borderRadius: 10,
    backgroundColor: (props) =>
      props.selected === "PRIVACY_POLICY" ? "#E3F2FD" : "#fff",
    cursor: "pointer",
    transition: "all 0.2s ease",
    textAlign: "center",
    position: "relative",
    "&:hover": {
      borderColor: theme.palette.primary.main,
      backgroundColor: "#E3F2FD",
    },
  },
  docTypeOptionTnc: {
    flex: 1,
    padding: theme.spacing(2.5, 2),
    border: (props) =>
      props.selected === "TERMS_AND_CONDITIONS"
        ? `2px solid ${theme.palette.primary.main}`
        : "2px solid #e0e0e0",
    borderRadius: 10,
    backgroundColor: (props) =>
      props.selected === "TERMS_AND_CONDITIONS" ? "#E3F2FD" : "#fff",
    cursor: "pointer",
    transition: "all 0.2s ease",
    textAlign: "center",
    position: "relative",
    "&:hover": {
      borderColor: theme.palette.primary.main,
      backgroundColor: "#E3F2FD",
    },
  },
  docTypeRadio: {
    position: "absolute",
    top: "12px",
    right: "12px",
    width: "20px",
    height: "20px",
    borderRadius: "50%",
    border: "2px solid #ccc",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  docTypeRadioSelected: {
    borderColor: theme.palette.primary.main,
    backgroundColor: theme.palette.primary.main,
  },
  docTypeRadioInner: {
    width: "8px",
    height: "8px",
    borderRadius: "50%",
    backgroundColor: "#fff",
  },
  docTypeIcon: {
    fontSize: "2rem",
    marginBottom: theme.spacing(1),
    color: (props) =>
      props.selected === "PRIVACY_POLICY"
        ? theme.palette.primary.main
        : "#9e9e9e",
  },
  docTypeIconTnc: {
    fontSize: "2rem",
    marginBottom: theme.spacing(1),
    color: (props) =>
      props.selected === "TERMS_AND_CONDITIONS"
        ? theme.palette.primary.main
        : "#9e9e9e",
  },
  docTypeLabel: {
    fontSize: "0.9rem",
    fontWeight: 600,
    color: (props) =>
      props.selected === "PRIVACY_POLICY"
        ? theme.palette.primary.main
        : theme.palette.text.primary,
  },
  docTypeLabelTnc: {
    fontSize: "0.9rem",
    fontWeight: 600,
    color: (props) =>
      props.selected === "TERMS_AND_CONDITIONS"
        ? theme.palette.primary.main
        : theme.palette.text.primary,
  },
  uploadZone: {
    border: "2px dashed #d0d7de",
    borderRadius: 10,
    padding: theme.spacing(4),
    textAlign: "center",
    backgroundColor: "#fafbfc",
    transition: "all 0.2s ease",
    cursor: "pointer",
    marginBottom: theme.spacing(3),
    "&:hover": {
      borderColor: theme.palette.primary.main,
      backgroundColor: "#f0f7ff",
    },
  },
  uploadZoneIcon: {
    fontSize: "2.5rem",
    color: theme.palette.primary.main
  },
  uploadZoneText: {
    fontSize: "0.9rem",
    color: theme.palette.text.primary,
    fontWeight: 500,
  },
  fileRow: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(1.5, 2),
    backgroundColor: "#f8f9fa",
    borderRadius: theme.shape.borderRadius,
    border: "1px solid #e8ecf1",
    marginBottom: theme.spacing(2),
  },
  fileIcon: {
    fontSize: "1.5rem",
    color: theme.palette.primary.main,
    marginRight: theme.spacing(1.5),
  },
  fileName: {
    fontSize: "0.85rem",
    fontWeight: 500,
    color: theme.palette.text.primary,
    wordBreak: "break-all",
  },
  fileRemove: {
    color: "#999",
    cursor: "pointer",
    "&:hover": {
      color: "#e53935",
    },
  },
  buttonRow: {
    display: "flex",
    justifyContent: "flex-end",
    gap: theme.spacing(2),
    paddingTop: theme.spacing(1)
  },
  primaryButton: {
    height: "42px",
    textTransform: "none",
    fontSize: "0.875rem !important",
    fontWeight: 600,
    borderRadius: 10,
  },
  secondaryButton: {
    height: "42px",
    textTransform: "none",
    fontSize: "0.875rem !important",
    fontWeight: 600,
    borderRadius: 10,
    border: "1px solid #e0e0e0",
  },
  uploadingText: {
    fontSize: "0.85rem",
    color: theme.palette.primary.main,
    fontWeight: 500,
  },
  uploadingIcon: {
    fontSize: "1.1rem",
    color: theme.palette.primary.main,
  },
}));

const PolicyUpload = (props) => {
  const dispatch = useDispatch();
  const loginUserData = useSelector((state) => state.OAuth.loginUserData || {});
  const [docSelected, setDocSelected] = useState("");
  const [file, setFile] = useState(null);
  const [localPath, setLocalPath] = useState("");
  const [uploading, setUploading] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const classes = useStyles({ selected: docSelected });
  const history = useHistory();
  const fileInputRef = React.useRef(null);
  const theme = useTheme();

  const bindScreen = (e) => {
    var confirmationMessage = "o/";
    (e || window.event).returnValue = confirmationMessage;
    return confirmationMessage;
  };

  useEffect(() => { }, []);

  const handleDragEnter = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setIsDragging(true);
  };

  const handleDragLeave = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setIsDragging(false);
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };

  const handleDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setIsDragging(false);

    const droppedFile = event.dataTransfer.files[0];
    if (droppedFile && droppedFile.type === "application/pdf") {
      setFile(droppedFile);
      setLocalPath(
        droppedFile.name + " (" + (droppedFile.size / (1024 * 1024)).toFixed(2) + " MB)"
      );
    } else {
      dispatch(setSnackbar(true, "error", "Please drop a valid PDF file"));
    }
  };

  const onFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile !== undefined) {
      setFile(selectedFile);
      setLocalPath(
        selectedFile.name + " (" + (selectedFile.size / (1024 * 1024)).toFixed(2) + " MB)"
      );
    }
  };

  const removeFile = () => {
    setFile(null);
    setLocalPath("");
  };

  const submit = () => {
    if (!file || !docSelected) return;
    setUploading(true);
    let formData = new FormData();
    formData.append("file", file);
    window.addEventListener("beforeunload", bindScreen, true);
    dispatch(OAuthActions.uploadPolicy(docSelected, formData)).then(function (
      success
    ) {
      window.removeEventListener("beforeunload", bindScreen, true);
      setUploading(false);
      if (success["error"] === undefined) {
        dispatch(setSnackbar(true, "success", "Upload document Successful"));
        // Re-fetch the login user so the policy consent/acknowledge dialog
        // in Main.js re-evaluates the (now reset) acceptance flags.
        if (loginUserData.uid) {
          dispatch(OAuthActions.getLoginUser(loginUserData.uid));
        }
        history.push("/dashboard");
      } else {
        dispatch(
          setAlertDialog(
            true,
            null,
            "error",
            "Document Upload",
            "Document upload was unsuccessful. Please check if the provided file is a PDF and try again.\nDetails Of Failure: " +
            success.message,
            "OK",
            ""
          )
        );
      }
    });
  };

  const handleDocTypeSelect = (type) => {
    setDocSelected(type);
  };

  return (
    <div className={classes.root}>
      <Box className={classes.pageHeaderLeft}>
        <Box className={classes.pageIconBox}>
          <InsertDriveFileIcon style={{ fontSize: 22, color: "white" }} />
        </Box>

        <Typography variant="h5">
          <strong style={{ fontSize: "1.4rem" }}>Policy Management</strong>
        </Typography>
      </Box>

      {/* Form Card */}
      <div className={classes.formCard}>
        <div className={classes.formCardBody}>
          <div className={classes.sectionHeader}>
            <Typography variant="subtitle1" className={classes.sectionTitle}>
              Document Type
            </Typography>
          </div>
          <div className={classes.docTypeContainer}>
            <div className={classes.docTypeOption} onClick={() => handleDocTypeSelect("PRIVACY_POLICY")}>
              <div className={`${classes.docTypeRadio} ${docSelected === "PRIVACY_POLICY" ? classes.docTypeRadioSelected : ""}`}>
                {docSelected === "PRIVACY_POLICY" && <div className={classes.docTypeRadioInner} />}
              </div>
              <InsertDriveFileIcon className={classes.docTypeIcon} />
              <Typography variant="body2" className={classes.docTypeLabel}>
                Privacy Policy
              </Typography>
            </div>
            <div className={classes.docTypeOptionTnc} onClick={() => handleDocTypeSelect("TERMS_AND_CONDITIONS")}>
              <div className={`${classes.docTypeRadio} ${docSelected === "TERMS_AND_CONDITIONS" ? classes.docTypeRadioSelected : ""}`}>
                {docSelected === "TERMS_AND_CONDITIONS" && <div className={classes.docTypeRadioInner} />}
              </div>
              <InsertDriveFileIcon className={classes.docTypeIconTnc} />
              <Typography variant="body2" className={classes.docTypeLabelTnc}>
                Terms & Conditions
              </Typography>
            </div>
          </div>

          {/* Section 2: File Upload */}
          <input
            type="file"
            id="upload-policy-file"
            accept=".pdf"
            onChange={onFileChange}
            style={{ display: "none" }}
          />
          <div className={classes.sectionHeader}>
            <Typography variant="subtitle1" className={classes.sectionTitle}>
              Upload File
            </Typography>
          </div>

          {!file ? (
            <label htmlFor="upload-policy-file">
              <div
                className={classes.uploadZone}
                style={{
                  borderColor: isDragging ? theme.palette.primary.main : undefined,
                  backgroundColor: isDragging ? "#f0f7ff" : undefined
                }}
                onDragEnter={handleDragEnter}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
              >
                <CloudUploadIcon className={classes.uploadZoneIcon} />
                <Typography variant="body2" className={classes.uploadZoneText}>
                  Drag & drop your PDF here, or{" "}
                  <span className={classes.uploadZoneLink}>browse</span>
                </Typography>
              </div>
            </label>
          ) : (
            <div className={classes.fileRow}>
              <InsertDriveFileIcon className={classes.fileIcon} />
              <div className={classes.fileInfo}>
                <Typography variant="body2" className={classes.fileName}>
                  {localPath}
                </Typography>
              </div>
              <CloseIcon
                className={classes.fileRemove}
                onClick={removeFile}
                style={{ marginLeft: "auto" }}
              />
            </div>
          )}

          {/* Uploading State */}
          {uploading && (
            <div className={classes.uploadingBanner}>
              <CloudUploadIcon className={classes.uploadingIcon} />
              <Typography variant="body2" className={classes.uploadingText}>
                Uploading your document...
              </Typography>
            </div>
          )}

          {/* Action Buttons */}
          <div className={classes.buttonRow}>
            <Button
              variant="outlined"
              className={classes.secondaryButton}
              onClick={() => history.push("/dashboard")}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              className={classes.primaryButton}
              onClick={submit}
              disabled={!docSelected || !file || uploading}
            >
              {uploading ? "Uploading..." : "Upload Document"}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PolicyUpload;
